import {useMemo} from 'react';

import {Segment} from "@britishcouncil/react-extro-ui";

import * as S from './SideSectionProductList.styles';

interface SummaryProductListProps {
    title?: React.ReactNode;
    columnHeaders?: string[];
    items?: LineItem[];
    subtitle?: string;
}

export interface LineItem {
    label: string | undefined;
    amount: string;
}

const SummaryProductList = ({
                                title,
                                columnHeaders,
                                items,
                                subtitle,
                            }: SummaryProductListProps) => {
    const someItemsHaveLabel = useMemo(() => {
        if (!items || items.length === 0) {
            return false;
        }

        if (items.every((i) => !i.label)) {
            return false;
        }

        return true;
    }, [items]);

    const showItems = !!items?.length && someItemsHaveLabel;

    return (
        <Segment elevation={0}>
            {title && <S.Title>{title}</S.Title>}
            {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
            <S.Divider/>
            {showItems && (
                <>
                    {columnHeaders && columnHeaders.length > 0 && (
                        <S.Header>
                            {columnHeaders.map((col, index) => (
                                <h6 key={index}>{col}</h6>
                            ))}
                        </S.Header>
                    )}
                    <S.List>
                        {items.map((c, index) => (
                            <S.Item key={index}>
                                <S.ItemLabel>{c.label || '—'}</S.ItemLabel>
                                <S.ItemAmount>{c.amount}</S.ItemAmount>
                            </S.Item>
                        ))}
                    </S.List>
                </>
            )}
        </Segment>
        
    );
};

export default SummaryProductList;
